import {Box, Flex, Text} from '@chakra-ui/react'
import Header from './Header'
import ItemSentence from './ItemSentence'
import {useEffect, useState} from 'react'
import Loading from '@components/Loading'
import sentencePracticeRequest from '@apis/sentence-practice'

const ReviseSentenceOverview = () => {
  const [isLoading, setIsLoading] = useState<any>(true)
  const [folders, setFolders] = useState<any>([])

  useEffect(() => {
    getFoldersOverview()
  }, [])

  const getFoldersOverview = async () => {
    setIsLoading(true)
    const res = await sentencePracticeRequest.getOverview()
    if (res) {
      if (res.status === 200) {
        setFolders(res.data.data)
      }
    }
    setIsLoading(false)
  }

  return (
    <Box pt={{base: '16px', md: 0}} minH={'100vh'}>
      <Header folders={folders} />
      <Flex
        maxW={'1280px'}
        h={{base: 'unset', md: '500px'}}
        mx={{base: '16px', '2xl': 'auto'}}
        mt={{base: '-170px', md: '-200px'}}
        mb={'32px'}
        borderRadius={'20px'}
        bg={'white'}>
        <Box
          className="scroll-bar"
          m={'24px'}
          mr={'0px'}
          pr={'24px'}
          overflow={'auto'}
          flex={1}
          position={'relative'}>
          {!isLoading ? (
            Object.keys(folders?.overview_data).length > 0 ? (
              Object.keys(folders?.overview_data)?.map(
                (item: any, index: any) => (
                  <ItemSentence
                    key={index}
                    data={folders?.overview_data[item]}
                    title={item}
                  />
                ),
              )
            ) : (
              <Text>Chưa có câu nào cần ôn</Text>
            )
          ) : (
            <Loading />
          )}
        </Box>
      </Flex>
    </Box>
  )
}

export default ReviseSentenceOverview
